
import { defineComponent, reactive, ref } from 'vue';
import marked from 'marked';
import sampleMd from '../assets/sample';

const renderStatusComposition = () => {
  const status = reactive<{ latest: number; average: number }>({ latest: 0, average: 0 });
  const updateSpeed = (start: number, end: number) => {
    const duration = end - start;
    status.latest = Math.floor(duration * 1000) / 1000;
    status.average = Math.floor(((status.average + duration) / 2) * 1000) / 1000;
  };

  return { status, updateSpeed };
};

const sourceComposition = () => {
  const source = reactive<{ content: string; html: string }>({ content: sampleMd, html: '' });
  const updateHtml = () => {
    const markedHtml = marked(source.content);
    source.html = markedHtml;
  };

  return { source, updateHtml };
};

export default defineComponent({
  name: 'PageJS',
  components: {},
  setup() {
    const autoUpdate = ref<boolean>(true);

    const { source, updateHtml } = sourceComposition();
    const { status, updateSpeed } = renderStatusComposition();

    const executeUpdateSequence = () => {
      const start = performance.now();
      updateHtml();
      const end = performance.now();
      updateSpeed(start, end);
    };

    const keyupHandler = () => {
      if (!autoUpdate.value) return;

      executeUpdateSequence();
    };

    const blurHandler = (e: KeyboardEvent) => {
      autoUpdate.value;
      const target = e.target as HTMLTextAreaElement;
      if (target) target.disabled = true;

      executeUpdateSequence();

      target.disabled = false;
    };

    updateHtml();
    return { autoUpdate, blurHandler, source, status, keyupHandler };
  },
});
